import { emailLogsList, emailLogsMailClasses } from '@/services/emailLogs.service'

export default {
	namespaced: true,
	state: {
		logList: {
			data: [],
			meta: { pagination: { total: 0 } },
		},
		mailClasses: [],
		logStatus: 'init',
	},
	getters: {
		getLogList(state) {
			return state.logList
		},
		getLogStatus(state) {
			return state.logStatus
		},
		getMailClasses(state) {
			return state.mailClasses
		},
	},
	mutations: {
		SET_LOG_LIST(state, value) {
			state.logList = value
		},
		SET_MAIL_CLASSES(state, value) {
			state.mailClasses = value
		},
		SET_LOG_STATUS(state, value) {
			state.logStatus = value
		},
	},
	actions: {
		async fetchLogList({ commit }, params) {
			commit('SET_LOG_STATUS', 'pending')
			try {
				const { data } = await emailLogsList(params)
				commit('SET_LOG_LIST', data)
				commit('SET_LOG_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_LOG_STATUS', 'init')
				throw error
			}
		},
		async fetchMailClasses({ commit }) {
			try {
				const { data } = await emailLogsMailClasses()
				commit('SET_MAIL_CLASSES', data.data || [])
			} catch (error) {
				console.error('Error fetching mail classes:', error)
			}
		},
	},
}
